import { COLORS } from '@/config';

import { DENSE_TYPES, WIDGET_COLUMNS_GROUPS, INFOS_NAME_VARIABLE, INFOS_VARIABLE_PREFIX } from './common';

export const ALARM_FIELDS = {
  id: '_id',
  assignedInstructions: 'assigned_instructions',
  displayName: 'v.display_name',
  output: 'v.output',
  longOutput: 'v.long_output',
  initialOutput: 'v.initial_output',
  initialLongOutput: 'v.initial_long_output',
  connector: 'v.connector',
  connectorName: 'v.connector_name',
  component: 'v.component',
  resource: 'v.resource',
  lastComment: 'v.last_comment.m',
  lastCommentInitiator: 'v.last_comment.initiator',
  lastCommentAuthor: 'v.last_comment.a',
  ackBy: 'v.ack.a',
  ackMessage: 'v.ack.m',
  ackInitiator: 'v.ack.initiator',
  stateMessage: 'v.state.m',
  statusMessage: 'v.status.m',
  state: 'v.state.val',
  maxState: 'v.max_state',
  initialState: 'v.initial_state',
  stateInitiator: 'v.state.initiator',
  status: 'v.status.val',
  totalStateChanges: 'v.total_state_changes',
  timestamp: 't',
  creationDate: 'v.creation_date',
  lastUpdateDate: 'v.last_update_date',
  lastEventDate: 'v.last_event_date',
  ackAt: 'v.ack.t',
  stateAt: 'v.state.t',
  statusAt: 'v.status.t',
  resolved: 'v.resolved',
  activationDate: 'v.activation_date',
  duration: 'v.duration',
  currentStateDuration: 'v.current_state_duration',
  snoozeDuration: 'v.snooze_duration',
  snoozeAuthor: 'v.snooze.a',
  snoozeInitiator: 'v.snooze.initiator',
  pbhInactiveDuration: 'v.pbh_inactive_duration',
  activeDuration: 'v.active_duration',
  eventsCount: 'v.events_count',
  tags: 'tags',
  extraDetails: 'extra_details',
  impactState: 'impact_state',
  infos: 'v.infos',
  links: 'links',
  ticketAuthor: 'v.ticket.a',
  ticketMessage: 'v.ticket.m',
  ticketInitiator: 'v.ticket.initiator',
  ticketValue: 'v.ticket.ticket',
  ticketCreatedAt: 'v.ticket.t',
  changeState: 'v.change_state',
  meta: 'v.meta',
  entityId: 'entity._id',
  entityName: 'entity.name',
  entityCategoryName: 'entity.category.name',
  entityType: 'entity.type',
  entityComponent: 'entity.component',
  entityConnector: 'entity.connector',
  entityImpactLevel: 'entity.impact_level',
  entityKoEvents: 'entity.ko_events',
  entityOkEvents: 'entity.ok_events',
  entityInfos: 'entity.infos',
  entityComponentInfos: 'entity.component_infos',
  entityLastPbehaviorDate: 'entity.last_pbehavior_date',
  pbehaviorInfoId: 'v.pbehavior_info.id',
  pbehaviorInfoName: 'v.pbehavior_info.name',
  pbehaviorInfoReason: 'v.pbehavior_info.reason',
  pbehaviorInfoType: 'v.pbehavior_info.type',
  pbehaviorInfoCanonicalType: 'v.pbehavior_info.canonical_type',

  /**
   * OBJECTS
   */
  ack: 'v.ack',
  ticket: 'v.ticket',
  ticketData: 'v.ticket.ticket_data',
  canceled: 'v.canceled',
  canceledInitiator: 'v.canceled.initiator',
  snooze: 'v.snooze',
  pbehaviorInfo: 'v.pbehavior_info',
  stateObject: 'v.state',
  statusObject: 'v.status',

  /**
   * VIRTUAL
   */
  activated: 'activated',
};

export const ALARM_INFOS_FIELDS = [
  ALARM_FIELDS.infos,
  ALARM_FIELDS.entityInfos,
  ALARM_FIELDS.entityComponentInfos,
];

export const ALARM_OUTPUT_FIELDS = [
  ALARM_FIELDS.output,
  ALARM_FIELDS.longOutput,
  ALARM_FIELDS.initialOutput,
  ALARM_FIELDS.initialLongOutput,
];

export const ALARM_FIELDS_WITHOUT_FILTER_ON_CLICK = [
  ALARM_FIELDS.id,
  ALARM_FIELDS.extraDetails,
  ALARM_FIELDS.links,
  ALARM_FIELDS.tags,
  ALARM_FIELDS.eventsCount,
  ALARM_FIELDS.impactState,
  ALARM_FIELDS.initialState,
  ALARM_FIELDS.maxState,
  ALARM_FIELDS.timestamp,
  ALARM_FIELDS.creationDate,
  ALARM_FIELDS.lastUpdateDate,
  ALARM_FIELDS.lastEventDate,
  ALARM_FIELDS.ackAt,
  ALARM_FIELDS.resolved,
  ALARM_FIELDS.activationDate,
  ALARM_FIELDS.duration,
  ALARM_FIELDS.currentStateDuration,
  ALARM_FIELDS.snoozeDuration,
  ALARM_FIELDS.pbhInactiveDuration,
  ALARM_FIELDS.activeDuration,
  ALARM_FIELDS.infos,
  ALARM_FIELDS.assignedInstructions,
  ALARM_FIELDS.changeState,
  ALARM_FIELDS.stateAt,
  ALARM_FIELDS.statusAt,
  ALARM_FIELDS.stateMessage,
  ALARM_FIELDS.statusMessage,

  ALARM_FIELDS.entityId,
  ALARM_FIELDS.entityOkEvents,
  ALARM_FIELDS.entityKoEvents,
  ALARM_FIELDS.entityLastPbehaviorDate,
  ALARM_FIELDS.entityInfos,
  ALARM_FIELDS.entityComponentInfos,

  ALARM_FIELDS.ticketCreatedAt,
  ALARM_FIELDS.ticketAuthor,
  ALARM_FIELDS.ticketData,
];

export const ALARM_LEVELS = {
  minor: 20,
  major: 30,
  critical: 40,
};

export const ALARM_LEVELS_COLORS = {
  ok: COLORS.state.ok,
  minor: COLORS.state.minor,
  major: COLORS.state.major,
  critical: COLORS.state.critical,
};

export const ALARM_STATES = {
  ok: 0,
  minor: 1,
  major: 2,
  critical: 3,
};

export const ALARM_STATES_KEYS = {
  ok: 'ok',
  minor: 'minor',
  major: 'major',
  critical: 'critical',
};

export const ALARM_STATES_TEXTS = {
  [ALARM_STATES.ok]: 'ok',
  [ALARM_STATES.minor]: 'minor',
  [ALARM_STATES.major]: 'major',
  [ALARM_STATES.critical]: 'critical',
};

export const ALARM_STATES_ICONS = {
  [ALARM_STATES.ok]: 'assistant_photo',
  [ALARM_STATES.minor]: 'assistant_photo',
  [ALARM_STATES.major]: 'assistant_photo',
  [ALARM_STATES.critical]: 'assistant_photo',
};

export const ALARM_STATES_CLASSES = {
  [ALARM_STATES.ok]: 'state-ok',
  [ALARM_STATES.minor]: 'state-minor',
  [ALARM_STATES.major]: 'state-major',
  [ALARM_STATES.critical]: 'state-critical',
};

export const ALARM_STATES_UNKNOWN_CLASS = 'state-unknown';

export const ALARM_STATUSES = {
  closed: 0,
  ongoing: 1,
  stealthy: 2,
  flapping: 3,
  cancelled: 4,
  noEvents: 5,
  unknown: 6,
};

export const ALARM_STATUSES_ICONS = {
  [ALARM_STATUSES.closed]: '$vuetify.icons.delayed_check',
  [ALARM_STATUSES.ongoing]: 'warning',
  [ALARM_STATUSES.stealthy]: 'swap_vert',
  [ALARM_STATUSES.flapping]: 'swap_vert',
  [ALARM_STATUSES.cancelled]: '$vuetify.icons.delayed_cancel',
  [ALARM_STATUSES.noEvents]: 'sync_problem',
  [ALARM_STATUSES.unknown]: '$vuetify.icons.question_mark',
};

export const ALARM_STATUSES_CLASSES = {
  [ALARM_STATUSES.closed]: 'status-closed',
  [ALARM_STATUSES.ongoing]: 'status-ongoing',
  [ALARM_STATUSES.stealthy]: 'status-stealthy',
  [ALARM_STATUSES.flapping]: 'status-flapping',
  [ALARM_STATUSES.cancelled]: 'status-cancelled',
  [ALARM_STATUSES.noEvents]: 'status-noEvents',
  [ALARM_STATUSES.unknown]: 'status-unknown',
};

export const ALARM_STATUSES_RESOLVED_ICONS = {
  [ALARM_STATUSES.closed]: 'check_circle',
  [ALARM_STATUSES.cancelled]: 'cancel',
};

export const ALARM_STATUSES_TEXTS = {
  [ALARM_STATUSES.closed]: 'closed',
  [ALARM_STATUSES.ongoing]: 'ongoing',
  [ALARM_STATUSES.stealthy]: 'stealthy',
  [ALARM_STATUSES.flapping]: 'flapping',
  [ALARM_STATUSES.cancelled]: 'cancelled',
  [ALARM_STATUSES.noEvents]: 'no events',
  [ALARM_STATUSES.unknown]: 'unknown',
};

export const ALARM_LIST_ACTIONS_TYPES = {
  pbehaviorAdd: 'pbehaviorAdd',
  fastPbehaviorAdd: 'fastPbehaviorAdd',
  fastPbehaviorRemove: 'fastPbehaviorRemove',
  moreInfos: 'moreInfos',
  snooze: 'snooze',
  declareTicket: 'declareTicket',
  associateTicket: 'associateTicket',
  removeAssociatedTicket: 'removeAssociatedTicket',
  changeState: 'changeState',
  variablesHelp: 'variablesHelp',
  history: 'history',
  exportPdf: 'exportPdf',
  linkToMetaAlarm: 'linkToMetaAlarm',
  removeAlarmsFromManualMetaAlarm: 'removeAlarmsFromManualMetaAlarm',
  removeAlarmsFromAutoMetaAlarm: 'removeAlarmsFromAutoMetaAlarm',
  comment: 'comment',

  ack: 'ack',
  fastAck: 'fastAck',
  ackRemove: 'ackRemove',

  cancel: 'cancel',
  fastCancel: 'fastCancel',
  unCancel: 'unCancel',

  links: 'links',

  correlation: 'correlation',

  listFilters: 'listFilters',
  editFilter: 'editFilter',
  addFilter: 'addFilter',
  userFilter: 'userFilter',

  listRemediationInstructionsFilters: 'listRemediationInstructionsFilters',
  editRemediationInstructionsFilter: 'editRemediationInstructionsFilter',
  addRemediationInstructionsFilter: 'addRemediationInstructionsFilter',
  userRemediationInstructionsFilter: 'userRemediationInstructionsFilter',

  executeInstruction: 'executeInstruction',

  addBookmark: 'addBookmark',
  removeBookmark: 'removeBookmark',
};

export const ALARM_LIST_ACTIONS_TYPES_ICONS = {
  [ALARM_LIST_ACTIONS_TYPES.pbehaviorAdd]: 'pause',
  [ALARM_LIST_ACTIONS_TYPES.fastPbehaviorAdd]: 'motion_photos_paused',
  [ALARM_LIST_ACTIONS_TYPES.fastPbehaviorRemove]: 'play_arrow',
  [ALARM_LIST_ACTIONS_TYPES.snooze]: 'alarm',
  [ALARM_LIST_ACTIONS_TYPES.declareTicket]: 'note_add',
  [ALARM_LIST_ACTIONS_TYPES.associateTicket]: 'sticky_note_2',
  [ALARM_LIST_ACTIONS_TYPES.removeAssociatedTicket]: '$vuetify.icons.remove_note',
  [ALARM_LIST_ACTIONS_TYPES.changeState]: 'thumbs_up_down',
  [ALARM_LIST_ACTIONS_TYPES.variablesHelp]: 'help',
  [ALARM_LIST_ACTIONS_TYPES.history]: 'history',
  [ALARM_LIST_ACTIONS_TYPES.exportPdf]: 'assignment_returned',
  [ALARM_LIST_ACTIONS_TYPES.linkToMetaAlarm]: 'center_focus_strong',
  [ALARM_LIST_ACTIONS_TYPES.removeAlarmsFromManualMetaAlarm]: 'link_off',
  [ALARM_LIST_ACTIONS_TYPES.removeAlarmsFromAutoMetaAlarm]: 'link_off',
  [ALARM_LIST_ACTIONS_TYPES.comment]: 'comment',

  [ALARM_LIST_ACTIONS_TYPES.ack]: 'check',
  [ALARM_LIST_ACTIONS_TYPES.fastAck]: 'done_all',
  [ALARM_LIST_ACTIONS_TYPES.ackRemove]: 'remove_done',

  [ALARM_LIST_ACTIONS_TYPES.cancel]: 'block',
  [ALARM_LIST_ACTIONS_TYPES.fastCancel]: 'delete',
  [ALARM_LIST_ACTIONS_TYPES.unCancel]: 'delete_forever',

  [ALARM_LIST_ACTIONS_TYPES.executeInstruction]: 'assignment',

  [ALARM_LIST_ACTIONS_TYPES.addBookmark]: 'bookmark_add',
  [ALARM_LIST_ACTIONS_TYPES.removeBookmark]: 'bookmark_remove',
};

export const ALARM_LIST_TOGGLE_ACTIONS_TYPES_MAP = {
  [ALARM_LIST_ACTIONS_TYPES.removeBookmark]: ALARM_LIST_ACTIONS_TYPES.addBookmark,
  [ALARM_LIST_ACTIONS_TYPES.removeAssociatedTicket]: ALARM_LIST_ACTIONS_TYPES.associateTicket,
  [ALARM_LIST_ACTIONS_TYPES.fastPbehaviorRemove]: ALARM_LIST_ACTIONS_TYPES.fastPbehaviorAdd,
};

export const UNIQUE_ALARM_LIST_ACTIONS_TYPES_TO_LABELS_KEYS = {
  // Acknowledgment actions
  [ALARM_LIST_ACTIONS_TYPES.ack]: 'alarm.actions.titles.ack',
  [ALARM_LIST_ACTIONS_TYPES.fastAck]: 'alarm.actions.titles.fastAck',
  [ALARM_LIST_ACTIONS_TYPES.ackRemove]: 'alarm.actions.titles.ackRemove',

  // Cancel actions
  [ALARM_LIST_ACTIONS_TYPES.cancel]: 'alarm.actions.titles.cancel',
  [ALARM_LIST_ACTIONS_TYPES.unCancel]: 'alarm.actions.titles.unCancel',
  [ALARM_LIST_ACTIONS_TYPES.fastCancel]: 'alarm.actions.titles.fastCancel',

  // Pbehavior actions
  [ALARM_LIST_ACTIONS_TYPES.pbehaviorAdd]: 'alarm.actions.titles.pbehavior',
  [ALARM_LIST_ACTIONS_TYPES.fastPbehaviorAdd]: 'alarm.actions.titles.fastPbehaviorAdd',

  // Ticket actions
  [ALARM_LIST_ACTIONS_TYPES.declareTicket]: 'alarm.actions.titles.declareTicket',
  [ALARM_LIST_ACTIONS_TYPES.associateTicket]: 'alarm.actions.titles.associateTicket',

  // Meta alarm actions
  [ALARM_LIST_ACTIONS_TYPES.linkToMetaAlarm]: 'alarm.actions.titles.linkToMetaAlarm',
  [ALARM_LIST_ACTIONS_TYPES.removeAlarmsFromManualMetaAlarm]: 'alarm.actions.titles.removeAlarmsFromManualMetaAlarm',
  [ALARM_LIST_ACTIONS_TYPES.removeAlarmsFromAutoMetaAlarm]: 'alarm.actions.titles.removeAlarmsFromAutoMetaAlarm',

  // Information actions
  [ALARM_LIST_ACTIONS_TYPES.variablesHelp]: 'alarm.actions.titles.variablesHelp',
  [ALARM_LIST_ACTIONS_TYPES.history]: 'alarm.actions.titles.history',

  // Remediation instructions actions
  [ALARM_LIST_ACTIONS_TYPES.executeInstruction]: 'alarm.actions.titles.executeInstruction',

  // Bookmark actions
  [ALARM_LIST_ACTIONS_TYPES.addBookmark]: 'alarm.actions.titles.addBookmark',

  // Other actions
  [ALARM_LIST_ACTIONS_TYPES.comment]: 'alarm.actions.titles.comment',
  [ALARM_LIST_ACTIONS_TYPES.snooze]: 'alarm.actions.titles.snooze',
  [ALARM_LIST_ACTIONS_TYPES.links]: 'alarm.actions.titles.links',
};

export const UNIQUE_ALARM_LIST_MASS_ACTIONS_TYPES_TO_LABELS_KEYS = {
  // Acknowledgment actions
  [ALARM_LIST_ACTIONS_TYPES.ack]: 'alarm.actions.titles.ack',
  [ALARM_LIST_ACTIONS_TYPES.fastAck]: 'alarm.actions.titles.fastAck',
  [ALARM_LIST_ACTIONS_TYPES.ackRemove]: 'alarm.actions.titles.ackRemove',

  // Cancel actions
  [ALARM_LIST_ACTIONS_TYPES.cancel]: 'alarm.actions.titles.cancel',
  [ALARM_LIST_ACTIONS_TYPES.unCancel]: 'alarm.actions.titles.unCancel',
  [ALARM_LIST_ACTIONS_TYPES.fastCancel]: 'alarm.actions.titles.fastCancel',

  // Pbehavior actions
  [ALARM_LIST_ACTIONS_TYPES.pbehaviorAdd]: 'alarm.actions.titles.pbehavior',
  [ALARM_LIST_ACTIONS_TYPES.fastPbehaviorAdd]: 'alarm.actions.titles.fastPbehaviorAdd',

  // Ticket actions
  [ALARM_LIST_ACTIONS_TYPES.declareTicket]: 'alarm.actions.titles.declareTicket',
  [ALARM_LIST_ACTIONS_TYPES.associateTicket]: 'alarm.actions.titles.associateTicket',

  // Meta alarm actions
  [ALARM_LIST_ACTIONS_TYPES.linkToMetaAlarm]: 'alarm.actions.titles.linkToMetaAlarm',
  [ALARM_LIST_ACTIONS_TYPES.removeAlarmsFromManualMetaAlarm]: 'alarm.actions.titles.removeAlarmsFromManualMetaAlarm',
  [ALARM_LIST_ACTIONS_TYPES.removeAlarmsFromAutoMetaAlarm]: 'alarm.actions.titles.removeAlarmsFromAutoMetaAlarm',

  // Other actions
  [ALARM_LIST_ACTIONS_TYPES.comment]: 'alarm.actions.titles.comment',
  [ALARM_LIST_ACTIONS_TYPES.snooze]: 'alarm.actions.titles.snooze',
  [ALARM_LIST_ACTIONS_TYPES.links]: 'alarm.actions.titles.links',
};

export const ALARM_LIST_STEPS = {
  stateinc: 'stateinc',
  statedec: 'statedec',
  changeState: 'changestate',
  stateCounter: 'statecounter',

  statusinc: 'statusinc',
  statusdec: 'statusdec',
  resolve: 'resolve',
  activate: 'activate',

  ack: 'ack',
  ackRemove: 'ackremove',

  pbhenter: 'pbhenter',
  pbhleave: 'pbhleave',

  assocTicket: 'assocticket',
  ticketRemove: 'ticketremove',

  webhookStart: 'webhookstart',
  webhookInProgress: 'webhookinprogress',
  webhookComplete: 'webhookcomplete',
  webhookFail: 'webhookfail',

  declareTicket: 'declareticket',
  declareTicketFail: 'declareticketfail',
  declareTicketRuleInProgress: 'declareticketruleinprogress',
  declareTicketRuleComplete: 'declareticketrulecomplete',
  declareTicketRuleFail: 'declareticketrulefail',
  changeTicketStatus: 'changeticketstatus',

  snooze: 'snooze',
  unsnooze: 'unsnooze',

  comment: 'comment',

  metaalarmattach: 'metaalarmattach',
  metaalarmdetach: 'metaalarmdetach',

  instructionStart: 'instructionstart',
  instructionPause: 'instructionpause',
  instructionResume: 'instructionresume',
  instructionComplete: 'instructioncomplete',
  instructionAbort: 'instructionabort',
  instructionFail: 'instructionfail',

  autoInstructionStart: 'autoinstructionstart',
  autoInstructionComplete: 'autoinstructioncomplete',
  autoInstructionFail: 'autoinstructionfail',

  junitTestSuiteUpdate: 'junittestsuiteupdate',
  junitTestCaseUpdate: 'junittestcaseupdate',
};

export const ALARM_STEPS_ICONS = {
  [ALARM_LIST_STEPS.ack]: 'check',
  [ALARM_LIST_STEPS.ackRemove]: 'remove_done',
  [ALARM_LIST_STEPS.assocTicket]: 'sticky_note_2',
  [ALARM_LIST_STEPS.ticketRemove]: '$vuetify.icons.remove_note',
  [ALARM_LIST_STEPS.changeState]: 'warining',
  [ALARM_LIST_STEPS.declareTicket]: 'note_add',
  [ALARM_LIST_STEPS.declareTicketFail]: 'note_add',
  [ALARM_LIST_STEPS.webhookStart]: 'webhook',
  [ALARM_LIST_STEPS.webhookInProgress]: 'webhook',
  [ALARM_LIST_STEPS.webhookComplete]: 'webhook',
  [ALARM_LIST_STEPS.webhookFail]: 'webhook',
  [ALARM_LIST_STEPS.declareTicketRuleInProgress]: 'note_add',
  [ALARM_LIST_STEPS.declareTicketRuleComplete]: 'note_add',
  [ALARM_LIST_STEPS.declareTicketRuleFail]: 'note_add',
  [ALARM_LIST_STEPS.snooze]: 'alarm',
  [ALARM_LIST_STEPS.unsnooze]: 'alarm_off',
  [ALARM_LIST_STEPS.pbhenter]: 'pause',
  [ALARM_LIST_STEPS.pbhleave]: 'pause',
  [ALARM_LIST_STEPS.comment]: 'comment',
  [ALARM_LIST_STEPS.metaalarmattach]: 'center_focus_weak',
  [ALARM_LIST_STEPS.instructionStart]: '$vuetify.icons.manual_instruction',
  [ALARM_LIST_STEPS.instructionPause]: '$vuetify.icons.manual_instruction',
  [ALARM_LIST_STEPS.instructionResume]: '$vuetify.icons.manual_instruction',
  [ALARM_LIST_STEPS.instructionComplete]: '$vuetify.icons.manual_instruction',
  [ALARM_LIST_STEPS.instructionAbort]: '$vuetify.icons.manual_instruction',
  [ALARM_LIST_STEPS.instructionFail]: '$vuetify.icons.manual_instruction',
  [ALARM_LIST_STEPS.autoInstructionStart]: 'assignment',
  [ALARM_LIST_STEPS.autoInstructionComplete]: 'assignment',
  [ALARM_LIST_STEPS.autoInstructionFail]: 'assignment',
  [ALARM_LIST_STEPS.activate]: 'notifications',
  [ALARM_LIST_STEPS.resolve]: 'check_circle',
};

export const ALARM_STEPS_COLORS = {
  [ALARM_LIST_STEPS.ack]: COLORS.alarmSteps.ack,
  [ALARM_LIST_STEPS.ackRemove]: COLORS.alarmSteps.ackRemove,
  [ALARM_LIST_STEPS.snooze]: COLORS.alarmSteps.snooze,
  [ALARM_LIST_STEPS.comment]: COLORS.alarmSteps.comment,
  [ALARM_LIST_STEPS.junitTestCaseUpdate]: COLORS.alarmSteps.junitTestCaseUpdate,
  [ALARM_LIST_STEPS.junitTestSuiteUpdate]: COLORS.alarmSteps.junitTestCaseUpdate,
  [ALARM_LIST_STEPS.metaalarmattach]: COLORS.alarmSteps.metaalarmattach,
  [ALARM_LIST_STEPS.metaalarmdetach]: COLORS.alarmSteps.metaalarmattach,
  [ALARM_LIST_STEPS.instructionStart]: COLORS.alarmSteps.instruction,
  [ALARM_LIST_STEPS.instructionPause]: COLORS.alarmSteps.instruction,
  [ALARM_LIST_STEPS.instructionResume]: COLORS.alarmSteps.instruction,
  [ALARM_LIST_STEPS.instructionComplete]: COLORS.remediation.executionStatus.completed,
  [ALARM_LIST_STEPS.instructionAbort]: COLORS.remediation.executionStatus.aborted,
  [ALARM_LIST_STEPS.instructionFail]: COLORS.remediation.executionStatus.failed,
  [ALARM_LIST_STEPS.autoInstructionStart]: COLORS.alarmSteps.instruction,
  [ALARM_LIST_STEPS.autoInstructionComplete]: COLORS.remediation.executionStatus.completed,
  [ALARM_LIST_STEPS.autoInstructionFail]: COLORS.remediation.executionStatus.failed,
  [ALARM_LIST_STEPS.activate]: COLORS.alarmSteps.activate,
  [ALARM_LIST_STEPS.declareTicket]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.declareTicketFail]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.webhookStart]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.webhookInProgress]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.webhookComplete]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.webhookFail]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.webhookFail]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.declareTicketRuleInProgress]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.declareTicketRuleComplete]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.declareTicketRuleFail]: COLORS.alarmSteps.declareTicket,
  [ALARM_LIST_STEPS.resolve]: COLORS.alarmSteps.resolve,
};

export const ALARM_STEPS_WITH_AUTHOR_IN_TITLE = [
  ALARM_LIST_STEPS.statedec,
  ALARM_LIST_STEPS.stateinc,
  ALARM_LIST_STEPS.changeState,
  ALARM_LIST_STEPS.statusdec,
  ALARM_LIST_STEPS.statusinc,
  ALARM_LIST_STEPS.resolve,
  ALARM_LIST_STEPS.snooze,
  ALARM_LIST_STEPS.unsnooze,
  ALARM_LIST_STEPS.ack,
  ALARM_LIST_STEPS.ackRemove,
  ALARM_LIST_STEPS.pbhenter,
  ALARM_LIST_STEPS.pbhleave,
  ALARM_LIST_STEPS.assocTicket,
  ALARM_LIST_STEPS.ticketRemove,
  ALARM_LIST_STEPS.webhookStart,
  ALARM_LIST_STEPS.webhookComplete,
  ALARM_LIST_STEPS.webhookFail,
  ALARM_LIST_STEPS.declareTicketRuleComplete,
  ALARM_LIST_STEPS.declareTicketRuleFail,
  ALARM_LIST_STEPS.instructionStart,
  ALARM_LIST_STEPS.instructionPause,
  ALARM_LIST_STEPS.instructionResume,
  ALARM_LIST_STEPS.instructionComplete,
  ALARM_LIST_STEPS.instructionAbort,
  ALARM_LIST_STEPS.instructionFail,
  ALARM_LIST_STEPS.metaalarmattach,
  ALARM_LIST_STEPS.metaalarmdetach,
  ALARM_LIST_STEPS.comment,
];

export const ALARM_STEPS_WITH_LAUNCHED_IN_TITLE = [
  ALARM_LIST_STEPS.webhookComplete,
  ALARM_LIST_STEPS.webhookFail,
  ALARM_LIST_STEPS.declareTicketRuleComplete,
  ALARM_LIST_STEPS.declareTicketRuleFail,
];

export const ALARM_STEPS_WITH_CONDITION_FOR_AUTHOR_IN_TITLE = [
  ALARM_LIST_STEPS.webhookStart,
  ALARM_LIST_STEPS.webhookComplete,
  ALARM_LIST_STEPS.webhookFail,
];

export const ALARM_STEPS_TYPES = {
  comment: 'comment',
};

export const ALARM_UNKNOWN_VALUE = {
  color: COLORS.status.unknown,
  text: 'Invalid val',
  icon: 'clear',
};

export const ALARMS_LIST_TIME_LINE_SYSTEM_AUTHOR = 'canopsis.engine';

export const DEFAULT_ALARMS_WIDGET_COLUMNS = [
  { value: ALARM_FIELDS.connector, isHtml: true },
  { value: ALARM_FIELDS.connectorName, isHtml: true },
  { value: ALARM_FIELDS.component, isHtml: true },
  { value: ALARM_FIELDS.resource, isHtml: true },
  { value: ALARM_FIELDS.output, isHtml: true },
  { value: ALARM_FIELDS.extraDetails },
  { value: ALARM_FIELDS.state },
  { value: ALARM_FIELDS.status },
];

export const DEFAULT_ALARMS_WIDGET_GROUP_COLUMNS = [
  { value: ALARM_FIELDS.connector, isHtml: true },
  { value: ALARM_FIELDS.connectorName, isHtml: true },
  { value: ALARM_FIELDS.resource, isHtml: true },
  { value: ALARM_FIELDS.output, isHtml: true },
  { value: ALARM_FIELDS.extraDetails },
  { value: ALARM_FIELDS.state },
  { value: ALARM_FIELDS.status },
];

export const DEFAULT_CONTEXT_WIDGET_RESOLVED_ALARMS_COLUMNS = [
  { value: ALARM_FIELDS.id },
  { value: ALARM_FIELDS.creationDate },
  { value: ALARM_FIELDS.lastUpdateDate },
];

export const DEFAULT_CONTEXT_WIDGET_ACTIVE_ALARM_COLUMNS = [
  { value: ALARM_FIELDS.displayName },
  { value: ALARM_FIELDS.output },
  { value: ALARM_FIELDS.state },
  { value: ALARM_FIELDS.status },
];

export const ALARMS_OPENED_VALUES = {
  opened: true,
  all: null,
  resolved: false,
};

export const ALARM_BASIC_METRIC_PARAMETERS = {
  activeAlarms: 'active_alarms',
  createdAlarms: 'created_alarms',
  nonDisplayedAlarms: 'non_displayed_alarms',
  instructionAlarms: 'instruction_alarms',
  pbehaviorAlarms: 'pbehavior_alarms',
  correlationAlarms: 'correlation_alarms',
  ackAlarms: 'ack_alarms',
  cancelAckAlarms: 'cancel_ack_alarms',
  ackActiveAlarms: 'ack_active_alarms',
  ticketActiveAlarms: 'ticket_active_alarms',
  withoutTicketActiveAlarms: 'without_ticket_active_alarms',
  ratioCorrelation: 'ratio_correlation',
  ratioInstructions: 'ratio_instructions',
  ratioTickets: 'ratio_tickets',
  ratioNonDisplayed: 'ratio_non_displayed',
  ratioRemediatedAlarms: 'ratio_remediated_alarms',
  averageAck: 'average_ack',
  averageResolve: 'average_resolve',
  timeToAck: 'time_to_ack',
  timeToResolve: 'time_to_resolve',
  minAck: 'min_ack',
  maxAck: 'max_ack',
};

export const ALARM_OPTIONAL_METRIC_PARAMETERS = {
  manualInstructionAssignedAlarms: 'manual_instruction_assigned_alarms',
  manualInstructionExecutedAlarms: 'manual_instruction_executed_alarms',
  notAckedAlarms: 'not_acked_alarms',
  notAckedInHourAlarms: 'not_acked_in_hour_alarms',
  notAckedInFourHoursAlarms: 'not_acked_in_four_hours_alarms',
  notAckedInDayAlarms: 'not_acked_in_day_alarms',
  minResolve: 'min_resolve',
  maxResolve: 'max_resolve',
};

export const ALARM_METRIC_PARAMETERS = {
  ...ALARM_BASIC_METRIC_PARAMETERS,
  ...ALARM_OPTIONAL_METRIC_PARAMETERS,
};

export const ALARMS_LIST_HEADER_OPACITY_DELAY = 500;

export const ALARM_INTERVAL_FIELDS = {
  timestamp: 't',
  resolved: 'v.resolved',
  lastUpdateDate: 'v.last_update_date',
  lastEventDate: 'v.last_event_date',
};

const {
  ack,
  ticket,
  canceled,
  snooze,
  pbehaviorInfo,
  activated,

  ...alarmListWidgetColumns
} = ALARM_FIELDS;

export const ALARM_LIST_WIDGET_COLUMNS = alarmListWidgetColumns;

export const ALARM_LIST_WIDGET_GROUPED_COLUMNS = {
  [WIDGET_COLUMNS_GROUPS.basic]: [
    ALARM_FIELDS.id,
    ALARM_FIELDS.displayName,
    ALARM_FIELDS.connector,
    ALARM_FIELDS.connectorName,
    ALARM_FIELDS.component,
    ALARM_FIELDS.resource,
    ALARM_FIELDS.state,
    ALARM_FIELDS.maxState,
    ALARM_FIELDS.initialState,
    ALARM_FIELDS.status,
    ALARM_FIELDS.tags,
    ALARM_FIELDS.extraDetails,
    ALARM_FIELDS.impactState,
    ALARM_FIELDS.infos,
    ALARM_FIELDS.links,
  ],
  [WIDGET_COLUMNS_GROUPS.messages]: [
    ALARM_FIELDS.output,
    ALARM_FIELDS.longOutput,
    ALARM_FIELDS.initialOutput,
    ALARM_FIELDS.initialLongOutput,
    ALARM_FIELDS.lastComment,
    ALARM_FIELDS.lastCommentInitiator,
  ],
  [WIDGET_COLUMNS_GROUPS.dates]: [
    ALARM_FIELDS.timestamp,
    ALARM_FIELDS.creationDate,
    ALARM_FIELDS.lastUpdateDate,
    ALARM_FIELDS.lastEventDate,
    ALARM_FIELDS.stateAt,
    ALARM_FIELDS.statusAt,
    ALARM_FIELDS.ackAt,
    ALARM_FIELDS.resolved,
    ALARM_FIELDS.activationDate,
    ALARM_FIELDS.duration,
    ALARM_FIELDS.currentStateDuration,
    ALARM_FIELDS.snoozeDuration,
    ALARM_FIELDS.pbhInactiveDuration,
    ALARM_FIELDS.activeDuration,
  ],
  [WIDGET_COLUMNS_GROUPS.counters]: [
    ALARM_FIELDS.totalStateChanges,
    ALARM_FIELDS.eventsCount,
  ],
  [WIDGET_COLUMNS_GROUPS.entityParameters]: [
    ALARM_FIELDS.entityId,
    ALARM_FIELDS.entityName,
    ALARM_FIELDS.entityCategoryName,
    ALARM_FIELDS.entityComponent,
    ALARM_FIELDS.entityConnector,
    ALARM_FIELDS.entityImpactLevel,
    ALARM_FIELDS.entityKoEvents,
    ALARM_FIELDS.entityOkEvents,
    ALARM_FIELDS.entityInfos,
    ALARM_FIELDS.entityComponentInfos,
    ALARM_FIELDS.entityLastPbehaviorDate,
  ],
  [WIDGET_COLUMNS_GROUPS.ticketParameters]: [
    ALARM_FIELDS.ticketValue,
    ALARM_FIELDS.ticketAuthor,
    ALARM_FIELDS.ticketMessage,
    ALARM_FIELDS.ticketInitiator,
    ALARM_FIELDS.ticketCreatedAt,
    ALARM_FIELDS.ticketData,
  ],
  [WIDGET_COLUMNS_GROUPS.other]: [
    ALARM_FIELDS.ackBy,
    ALARM_FIELDS.ackMessage,
    ALARM_FIELDS.ackInitiator,
    ALARM_FIELDS.stateMessage,
    ALARM_FIELDS.statusMessage,
    ALARM_FIELDS.changeState,
    ALARM_FIELDS.canceledInitiator,
    ALARM_FIELDS.assignedInstructions,
  ],
};

export const ALARM_PATTERN_FIELDS = {
  displayName: ALARM_FIELDS.displayName,
  stateInitiator: ALARM_FIELDS.stateInitiator,
  state: ALARM_FIELDS.state,
  status: ALARM_FIELDS.status,
  component: ALARM_FIELDS.component,
  resource: ALARM_FIELDS.resource,
  connector: ALARM_FIELDS.connector,
  connectorName: ALARM_FIELDS.connectorName,
  creationDate: ALARM_FIELDS.creationDate,
  duration: ALARM_FIELDS.duration,
  infos: ALARM_FIELDS.infos,
  output: ALARM_FIELDS.output,
  lastEventDate: ALARM_FIELDS.lastEventDate,
  lastUpdateDate: ALARM_FIELDS.lastUpdateDate,
  activationDate: ALARM_FIELDS.activationDate,
  ack: ALARM_FIELDS.ack,
  ackAt: ALARM_FIELDS.ackAt,
  ackBy: ALARM_FIELDS.ackBy,
  ackMessage: ALARM_FIELDS.ackMessage,
  ackInitiator: ALARM_FIELDS.ackInitiator,
  resolved: ALARM_FIELDS.resolved,
  ticket: ALARM_FIELDS.ticket,
  canceled: ALARM_FIELDS.canceled,
  canceledInitiator: ALARM_FIELDS.canceledInitiator,
  snooze: ALARM_FIELDS.snooze,
  snoozeAuthor: ALARM_FIELDS.snoozeAuthor,
  snoozeInitiator: ALARM_FIELDS.snoozeInitiator,
  lastComment: ALARM_FIELDS.lastComment,
  lastCommentInitiator: ALARM_FIELDS.lastCommentInitiator,
  lastCommentAuthor: ALARM_FIELDS.lastCommentAuthor,
  longOutput: ALARM_FIELDS.longOutput,
  initialOutput: ALARM_FIELDS.initialOutput,
  initialLongOutput: ALARM_FIELDS.initialLongOutput,
  totalStateChanges: ALARM_FIELDS.totalStateChanges,
  tags: ALARM_FIELDS.tags,
  activated: ALARM_FIELDS.activated,
  ticketValue: ALARM_FIELDS.ticketValue,
  ticketMessage: ALARM_FIELDS.ticketMessage,
  ticketInitiator: ALARM_FIELDS.ticketInitiator,
  ticketData: ALARM_FIELDS.ticketData,
  changeState: ALARM_FIELDS.changeState,
  meta: ALARM_FIELDS.meta,
  entityId: ALARM_FIELDS.entityId,
  entityName: ALARM_FIELDS.entityName,
  entityCategoryName: ALARM_FIELDS.entityCategoryName,
  entityType: ALARM_FIELDS.entityType,
  entityComponent: ALARM_FIELDS.entityComponent,
  entityConnector: ALARM_FIELDS.entityConnector,
  entityImpactLevel: ALARM_FIELDS.entityImpactLevel,
  entityInfos: ALARM_FIELDS.entityInfos,
  entityComponentInfos: ALARM_FIELDS.entityComponentInfos,
  pbehaviorInfoId: ALARM_FIELDS.pbehaviorInfoId,
  pbehaviorInfoName: ALARM_FIELDS.pbehaviorInfoName,
  pbehaviorInfoReason: ALARM_FIELDS.pbehaviorInfoReason,
  pbehaviorInfoType: ALARM_FIELDS.pbehaviorInfoType,
  pbehaviorInfoCanonicalType: ALARM_FIELDS.pbehaviorInfoCanonicalType,
};

export const ALARM_EVENT_INITIATORS = {
  user: 'user',
  system: 'system',
  external: 'external',
};

export const ALARM_TEMPLATE_FIELDS = {
  id: `alarm.${ALARM_FIELDS.id}`,
  ack: `alarm.${ALARM_FIELDS.ack}`,
  state: `alarm.${ALARM_FIELDS.stateObject}`,
  maxState: `alarm.${ALARM_FIELDS.maxState}`,
  initialState: `alarm.${ALARM_FIELDS.initialState}`,
  status: `alarm.${ALARM_FIELDS.statusObject}`,
  ticket: `alarm.${ALARM_FIELDS.ticket}`,
  component: `alarm.${ALARM_FIELDS.component}`,
  connector: `alarm.${ALARM_FIELDS.connector}`,
  connectorName: `alarm.${ALARM_FIELDS.connectorName}`,
  resource: `alarm.${ALARM_FIELDS.resource}`,
  creationDate: `alarm.${ALARM_FIELDS.creationDate}`,
  displayName: `alarm.${ALARM_FIELDS.displayName}`,
  output: `alarm.${ALARM_FIELDS.output}`,
  lastUpdateDate: `alarm.${ALARM_FIELDS.lastUpdateDate}`,
  lastEventDate: `alarm.${ALARM_FIELDS.lastEventDate}`,
  pbehaviorInfo: `alarm.${ALARM_FIELDS.pbehaviorInfo}`,
  duration: `alarm.${ALARM_FIELDS.duration}`,
  eventsCount: `alarm.${ALARM_FIELDS.eventsCount}`,
};

export const ALARM_EXPORT_PDF_FIELDS = {
  currentDate: 'current_date',
  displayName: 'display_name',
  state: 'state',
  maxState: 'max_state',
  initialState: 'initial_state',
  status: 'status',
  connector: 'connector',
  connectorName: 'connector_name',
  component: 'component',
  resource: 'resource',
  initialOutput: 'initial_output',
  output: 'output',
  eventsCount: 'events_count',
  duration: 'duration',
  creationDate: 'creation_date',
  lastEventDate: 'last_event_date',
  lastUpdateDate: 'last_update_date',
  acknowledgeDate: 'acknowledge_date',
  resolved: 'resolved',
  activationDate: 'activation_date',
  infos: 'infos',
  pbehaviorInfo: 'pbehavior_info',
  ticket: 'ticket',
  comments: 'comments',
  tags: 'tags',
  links: 'links',
};

export const ALARM_EXPORT_PDF_FIELDS_TO_ORIGINAL_FIELDS = {
  [ALARM_EXPORT_PDF_FIELDS.currentDate]: 'current_date',
  [ALARM_EXPORT_PDF_FIELDS.displayName]: 'alarm.v.display_name',
  [ALARM_EXPORT_PDF_FIELDS.state]: 'alarm.v.state',
  [ALARM_EXPORT_PDF_FIELDS.maxState]: 'alarm.v.max_state',
  [ALARM_EXPORT_PDF_FIELDS.initialState]: 'alarm.v.initial_state',
  [ALARM_EXPORT_PDF_FIELDS.status]: 'alarm.v.status',
  [ALARM_EXPORT_PDF_FIELDS.connector]: 'alarm.v.connector',
  [ALARM_EXPORT_PDF_FIELDS.connectorName]: 'alarm.v.connector_name',
  [ALARM_EXPORT_PDF_FIELDS.component]: 'alarm.v.component',
  [ALARM_EXPORT_PDF_FIELDS.resource]: 'alarm.v.resource',
  [ALARM_EXPORT_PDF_FIELDS.initialOutput]: 'alarm.v.initial_output',
  [ALARM_EXPORT_PDF_FIELDS.output]: 'alarm.v.output',
  [ALARM_EXPORT_PDF_FIELDS.eventsCount]: 'alarm.v.events_count',
  [ALARM_EXPORT_PDF_FIELDS.duration]: 'alarm.v.duration',
  [ALARM_EXPORT_PDF_FIELDS.creationDate]: 'alarm.v.creation_date',
  [ALARM_EXPORT_PDF_FIELDS.lastEventDate]: 'alarm.v.last_event_date',
  [ALARM_EXPORT_PDF_FIELDS.lastUpdateDate]: 'alarm.v.last_update_date',
  [ALARM_EXPORT_PDF_FIELDS.acknowledgeDate]: 'alarm.v.acknowledge_date',
  [ALARM_EXPORT_PDF_FIELDS.resolved]: 'alarm.v.resolved',
  [ALARM_EXPORT_PDF_FIELDS.activationDate]: 'alarm.v.activation_date',
  [ALARM_EXPORT_PDF_FIELDS.infos]: 'alarm.v.infos',
  [ALARM_EXPORT_PDF_FIELDS.pbehaviorInfo]: 'alarm.v.pbehavior_info',
  [ALARM_EXPORT_PDF_FIELDS.ticket]: 'alarm.v.ticket',
  [ALARM_EXPORT_PDF_FIELDS.comments]: 'alarm.comments',
  [ALARM_EXPORT_PDF_FIELDS.tags]: 'alarm.tags',
  [ALARM_EXPORT_PDF_FIELDS.links]: 'alarm.links',
};

export const ALARM_FIELDS_TO_LABELS_KEYS = {
  [ALARM_FIELDS.id]: 'common.id',
  [ALARM_FIELDS.assignedInstructions]: 'alarm.fields.assignedInstructions',
  [ALARM_FIELDS.displayName]: 'alarm.fields.displayName',
  [ALARM_FIELDS.output]: 'common.output',
  [ALARM_FIELDS.longOutput]: 'common.longOutput',
  [ALARM_FIELDS.initialOutput]: 'alarm.fields.initialOutput',
  [ALARM_FIELDS.initialLongOutput]: 'alarm.fields.initialLongOutput',
  [ALARM_FIELDS.connector]: 'common.connector',
  [ALARM_FIELDS.connectorName]: 'common.connectorName',
  [ALARM_FIELDS.component]: 'common.component',
  [ALARM_FIELDS.resource]: 'common.resource',
  [ALARM_FIELDS.lastComment]: 'common.lastComment',
  [ALARM_FIELDS.lastCommentInitiator]: 'alarm.fields.lastCommentInitiator',
  [ALARM_FIELDS.lastCommentAuthor]: 'alarm.fields.lastCommentAuthor',
  [ALARM_FIELDS.ackBy]: 'alarm.fields.ackBy',
  [ALARM_FIELDS.ackMessage]: 'alarm.fields.ackMessage',
  [ALARM_FIELDS.ackInitiator]: 'alarm.fields.ackInitiator',
  [ALARM_FIELDS.stateMessage]: 'alarm.fields.stateMessage',
  [ALARM_FIELDS.statusMessage]: 'alarm.fields.statusMessage',
  [ALARM_FIELDS.state]: 'common.state',
  [ALARM_FIELDS.stateInitiator]: 'alarm.fields.stateInitiator',
  [ALARM_FIELDS.status]: 'common.status',
  [ALARM_FIELDS.totalStateChanges]: 'alarm.fields.totalStateChanges',
  [ALARM_FIELDS.timestamp]: 'common.timestamp',
  [ALARM_FIELDS.creationDate]: 'common.created',
  [ALARM_FIELDS.lastUpdateDate]: 'common.updated',
  [ALARM_FIELDS.lastEventDate]: 'common.lastEventDate',
  [ALARM_FIELDS.ackAt]: 'alarm.fields.ackAt',
  [ALARM_FIELDS.stateAt]: 'alarm.fields.stateAt',
  [ALARM_FIELDS.statusAt]: 'alarm.fields.statusAt',
  [ALARM_FIELDS.resolved]: 'alarm.fields.resolved',
  [ALARM_FIELDS.activationDate]: 'alarm.fields.activationDate',
  [ALARM_FIELDS.duration]: 'common.duration',
  [ALARM_FIELDS.currentStateDuration]: 'alarm.fields.currentStateDuration',
  [ALARM_FIELDS.snoozeDuration]: 'alarm.fields.snoozeDuration',
  [ALARM_FIELDS.snoozeAuthor]: 'alarm.fields.snoozeAuthor',
  [ALARM_FIELDS.snoozeInitiator]: 'alarm.fields.snoozeInitiator',
  [ALARM_FIELDS.pbhInactiveDuration]: 'alarm.fields.pbhInactiveDuration',
  [ALARM_FIELDS.activeDuration]: 'alarm.fields.activeDuration',
  [ALARM_FIELDS.eventsCount]: 'alarm.fields.eventsCount',
  [ALARM_FIELDS.tags]: 'common.tag',
  [ALARM_FIELDS.extraDetails]: 'alarm.fields.extraDetails',
  [ALARM_FIELDS.impactState]: 'common.impactState',
  [ALARM_FIELDS.infos]: 'common.infos',
  [ALARM_FIELDS.links]: 'common.link',
  [ALARM_FIELDS.ticketAuthor]: 'alarm.fields.ticketAuthor',
  [ALARM_FIELDS.ticketMessage]: 'alarm.fields.ticketMessage',
  [ALARM_FIELDS.ticketValue]: 'alarm.fields.ticketId',
  [ALARM_FIELDS.ticketInitiator]: 'alarm.fields.ticketInitiator',
  [ALARM_FIELDS.ticketCreatedAt]: 'alarm.fields.ticketCreatedAt',
  [ALARM_FIELDS.maxState]: 'alarm.fields.maxState',
  [ALARM_FIELDS.initialState]: 'alarm.fields.initialState',
  [ALARM_FIELDS.entityId]: 'common.entityId',
  [ALARM_FIELDS.entityName]: 'alarm.fields.entityName',
  [ALARM_FIELDS.entityCategoryName]: 'alarm.fields.entityCategoryName',
  [ALARM_FIELDS.entityType]: 'alarm.fields.entityType',
  [ALARM_FIELDS.entityComponent]: 'alarm.fields.entityComponent',
  [ALARM_FIELDS.entityConnector]: 'alarm.fields.entityConnector',
  [ALARM_FIELDS.entityImpactLevel]: 'alarm.fields.entityImpactLevel',
  [ALARM_FIELDS.entityKoEvents]: 'alarm.fields.entityKoEvents',
  [ALARM_FIELDS.entityOkEvents]: 'alarm.fields.entityOkEvents',
  [ALARM_FIELDS.entityInfos]: 'alarm.fields.entityInfos',
  [ALARM_FIELDS.entityComponentInfos]: 'alarm.fields.entityComponentInfos',
  [ALARM_FIELDS.entityLastPbehaviorDate]: 'alarm.fields.entityLastPbehaviorDate',
  [ALARM_FIELDS.changeState]: 'alarm.fields.changeState',
  [ALARM_FIELDS.meta]: 'alarm.metaAlarm',
  [ALARM_FIELDS.pbehaviorInfoId]: 'common.id',
  [ALARM_FIELDS.pbehaviorInfoName]: 'common.name',
  [ALARM_FIELDS.pbehaviorInfoReason]: 'common.reason',
  [ALARM_FIELDS.pbehaviorInfoType]: 'common.type',
  [ALARM_FIELDS.pbehaviorInfoCanonicalType]: 'common.canonicalType',

  /**
   * OBJECTS
   */
  [ALARM_FIELDS.ack]: 'common.ack',
  [ALARM_FIELDS.ticket]: 'common.ticket',
  [ALARM_FIELDS.ticketData]: 'alarm.fields.ticketData',
  [ALARM_FIELDS.canceled]: 'common.canceled',
  [ALARM_FIELDS.canceledInitiator]: 'alarm.fields.canceledInitiator',
  [ALARM_FIELDS.snooze]: 'common.snooze',
  [ALARM_FIELDS.pbehaviorInfo]: 'pbehavior.pbehaviorInfo',
  [ALARM_FIELDS.stateObject]: 'common.state',
  [ALARM_FIELDS.statusObject]: 'common.status',

  /**
   * VIRTUAL
   */
  [ALARM_FIELDS.activated]: 'common.activated',
};

export const ALARM_UNSORTABLE_FIELDS = [
  ALARM_FIELDS.extraDetails,
  ALARM_FIELDS.links,
  ALARM_FIELDS.tags,
];

export const ALARM_PAYLOAD_VARIABLES_PREFIXES = {
  alarm: '.Alarm',
  entity: '.Entity',
  entityInfos: `${INFOS_VARIABLE_PREFIX} .Entity.Infos`,
};

export const ALARM_PAYLOADS_VARIABLES = {
  alarm: ALARM_PAYLOAD_VARIABLES_PREFIXES.alarm,
  alarms: '.Alarms',
  id: '.ID',
  displayName: '.Value.DisplayName',
  connector: '.Value.Connector',
  component: '.Value.Component',
  connectorName: '.Value.ConnectorName',
  resource: '.Value.Resource',
  infos: '.Value.Infos',
  infosName: '.Value.Infos.%name%',
  initialOutput: '.Value.InitialOutput',
  tags: '.Value.Tags',
  stateMessage: '.Value.State.Message',
  stateValue: '.Value.State.Value',
  statusValue: '.Value.Status.Value',
  ticketAuthor: '.Value.Ticket.Author',
  ticketValue: '.Value.Ticket.Ticket',
  ticketMessage: '.Value.Ticket.Message',
  ackAuthor: '.Value.ACK.Author',
  ackMessage: '.Value.ACK.Message',
  lastCommentAuthor: '.Value.LastComment.Author',
  lastCommentMessage: '.Value.LastComment.Message',
  infosValue: `${INFOS_VARIABLE_PREFIX} ${INFOS_VARIABLE_PREFIX} .Alarm.Value.Infos "%rule_id%") "${INFOS_NAME_VARIABLE}")`,

  entityName: `${ALARM_PAYLOAD_VARIABLES_PREFIXES.entity}.Name`,
  entityInfosValue: `${ALARM_PAYLOAD_VARIABLES_PREFIXES.entityInfos} "${INFOS_NAME_VARIABLE}").Value`,
};

export const ACK_MODAL_ACTIONS_TYPES = {
  ack: 0,
  ackAndAssociateTicket: 1,
  ackAndDeclareTicket: 2,
};

export const ALARMS_EXPAND_PANEL_TABS = {
  moreInfos: 'moreInfos',
  timeLine: 'timeLine',
  ticketsDeclared: 'ticketsDeclared',
  pbehavior: 'pbehavior',
  alarmsChildren: 'alarmsChildren',
  trackSource: 'trackSource',
  impactChain: 'impactChain',
  entityGantt: 'entityGantt',
  charts: 'charts',
  remediation: 'remediation',
  availability: 'availability',
  entityEnrichments: 'entityEnrichments',
};

export const ALARM_LINK_ICON_CHIP_WIDTH = 26;

export const ALARM_LINK_ICON_CHIP_COLUMN_GAP = {
  [DENSE_TYPES.large]: 8,
  [DENSE_TYPES.medium]: 8,
  [DENSE_TYPES.small]: 4,
};

export const ALARM_LINK_TD_PADDINGS = {
  [DENSE_TYPES.large]: 8,
  [DENSE_TYPES.medium]: 6,
  [DENSE_TYPES.small]: 6,
};

export const ALARM_EXPORT_FILE_NAME_PREFIX = 'alarm';

export const MASS_ACTIONS_BUTTON_WIDTH = 36;

export const ALARM_ACTION_BUTTON_WIDTHS = {
  [DENSE_TYPES.large]: 36,
  [DENSE_TYPES.medium]: 36,
  [DENSE_TYPES.small]: 24,
};

export const ALARM_ACTION_BUTTON_MARGINS = {
  [DENSE_TYPES.large]: 8,
  [DENSE_TYPES.medium]: 0,
  [DENSE_TYPES.small]: 0,
};

export const ALARM_ACTIONS_PADDINGS = {
  [DENSE_TYPES.large]: 8,
  [DENSE_TYPES.medium]: 6,
  [DENSE_TYPES.small]: 6,
};

export const DEFAULT_ALARM_ACTIONS_INLINE_COUNT = 4;

export const DEFAULT_ALARMS_QUICK_ACTIONS = [
  ALARM_LIST_ACTIONS_TYPES.ack,
  ALARM_LIST_ACTIONS_TYPES.fastAck,
  ALARM_LIST_ACTIONS_TYPES.cancel,
];

export const DEFAULT_ALARM_MORE_INFO_TEMPLATE = '{{!--\n'
  + '  TEMPLATE "PLUS D\'INFOS"\n'
  + '  --------------------------------------------------------------------------\n'
  + '  - L\'objet racine du template est `alarm`.\n'
  + '  - Les boucles `{{#each}}` utilisent `{{this.propriete}}` pour accéder aux données.\n'
  + '  - Le style est 100% en ligne et les icônes au format Material Design.\n'
  + '--}}\n'
  + '<div style="font-family:Arial, sans-serif;color:#2c3e50;line-height:1.5">\n'
  + '\n'
  + '  {{!-- CARD 1: IDENTITÉ DE L\'ALARME --}}\n'
  + '  <table width="100%" style="background-color:#ffffff;border:1px solid #e0e0e0;border-radius:8px;margin-bottom:16px">\n'
  + '    <tbody><tr>\n'
  + '      <td>\n'
  + '        <h2 style="margin:0 0 8px 0;font-size:1.4em;display:flex;align-items:center;gap:10px;flex-wrap:wrap">\n'
  + '          {{state alarm.v.state.val}}\n'
  + '          <span>{{alarm.v.display_name}}</span>\n'
  + '          {{#if alarm.is_meta_alarm}}\n'
  + '            <span style="display:inline-flex;align-items:center;gap:6px;background-color:#e8eaf6;color:#3f51b5;border:1px solid #c5cae9;padding:4px 10px;border-radius:16px;font-size:0.9em;font-weight:500;line-height:1">\n'
  + '              <i class="v-icon notranslate material-icons theme--light" style="font-size:16px">hub</i>\n'
  + '              Méta Alarme\n'
  + '            </span>\n'
  + '          {{/if}}\n'
  + '        </h2>\n'
  + '        <div style="font-size:0.9em">\n'
  + '          <strong>Sévérité Max Atteinte :</strong> {{state alarm.v.max_state}}\n'
  + '          <span style="color:#757575;margin-left:12px">(Initialement : {{state alarm.v.initial_state}})</span>\n'
  + '        </div>\n'
  + '      </td>\n'
  + '    </tr>\n'
  + '  </tbody></table>\n'
  + '\n'
  + '  {{!-- CARD 2: CONTEXTE ET DONNÉES CLÉS --}}\n'
  + '  <table width="100%" style="background-color:#ffffff;border:1px solid #e0e0e0;border-radius:8px;margin-bottom:16px">\n'
  + '    <tbody><tr>\n'
  + '      <td>\n'
  + '        <h3 style="margin:0 0 12px 0;font-size:1.2em">Contexte</h3>\n'
  + '        <p style="margin:0 0 4px 0"><strong>Message Actuel :</strong> {{{alarm.v.output}}}</p>\n'
  + '        <p style="margin:0 0 16px 0;color:#5a6d80;font-size:0.9em"><strong>Message Initial :</strong> {{{alarm.v.initial_output}}}</p>\n'
  + '        <hr style="border:none;border-top:1px solid #e0e0e0;margin:16px 0">\n'
  + '        <table width="100%">\n'
  + '          <tbody><tr>\n'
  + '            <td width="50%" style="vertical-align:top;padding-right:10px">\n'
  + '              <ul style="margin:0;padding:0;list-style:none">\n'
  + '                <li style="padding-bottom:4px"><strong>Source :</strong> {{alarm.v.connector_name}}</li>\n'
  + '                <li style="padding-bottom:4px"><strong>Composant :</strong> {{alarm.v.component}}</li>\n'
  + '                <li><strong>Ressource :</strong> {{alarm.v.resource}}</li>\n'
  + '              </ul>\n'
  + '            </td>\n'
  + '            <td width="50%" style="vertical-align:top;padding-left:10px">\n'
  + '              <ul style="margin:0;padding:0;list-style:none">\n'
  + '                <li style="padding-bottom:4px"><strong>Début :</strong> {{timestamp alarm.v.creation_date format="long"}}</li>\n'
  + '                {{#if alarm.v.ticket}}\n'
  + '                  <li><strong>Ticket : </strong><a target="_blank" href="{{alarm.v.ticket.ticket_url}}">{{alarm.v.ticket.ticket}}</a></li>\n'
  + '                {{/if}}\n'
  + '              </ul>\n'
  + '            </td>\n'
  + '          </tr>\n'
  + '        </tbody></table>\n'
  + '        <div style="margin-top:20px">\n'
  + '          {{#copy alarm.v.display_name}}\n'
  + '            <a style="text-decoration:none;display:inline-flex;align-items:center;gap:6px;background-color:#f0f0f0;border:1px solid #ddd;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:0.9em;color:#2c3e50">\n'
  + '              <i class="v-icon notranslate material-icons theme--light" style="font-size:16px">content_copy</i>\n'
  + '              Copier ID\n'
  + '            </a>\n'
  + '          {{/copy}}\n'
  + '          <span style="display:inline-block;width:8px"></span>\n'
  + '          {{#copy (concat alarm.v.component "/" alarm.v.resource)}}\n'
  + '            <a style="text-decoration:none;display:inline-flex;align-items:center;gap:6px;background-color:#f0f0f0;border:1px solid #ddd;padding:5px 10px;border-radius:6px;cursor:pointer;font-size:0.9em;color:#2c3e50">\n'
  + '              <i class="v-icon notranslate material-icons theme--light" style="font-size:16px">content_copy</i>\n'
  + '              Copier C/R\n'
  + '            </a>\n'
  + '          {{/copy}}\n'
  + '        </div>\n'
  + '      </td>\n'
  + '    </tr>\n'
  + '  </tbody></table>\n'
  + '\n'
  + '  {{!-- CARD 3: STATISTIQUES --}}\n'
  + '  <table width="100%" style="background-color:#ffffff;border:1px solid #e0e0e0;border-radius:8px;margin-bottom:16px">\n'
  + '    <tbody><tr>\n'
  + '      <td>\n'
  + '        <h3 style="margin:0 0 12px 0;font-size:1.2em">Statistiques</h3>\n'
  + '        <table width="100%" style="text-align:center;border-spacing:12px 0;margin-left:-12px">\n'
  + '          <tbody><tr>\n'
  + '            <td width="33.3%" style="background-color:#f9f9f9;padding:12px;border-radius:6px">\n'
  + '              <div style="font-size:1.5em;font-weight:bold;color:#1976d2">{{duration alarm.v.duration}}</div>\n'
  + '              <div style="font-size:0.9em;color:#5a6d80">Durée Totale</div>\n'
  + '            </td>\n'
  + '            <td width="33.3%" style="background-color:#f9f9f9;padding:12px;border-radius:6px">\n'
  + '              <div style="font-size:1.5em;font-weight:bold;color:#1976d2">{{alarm.v.events_count}}</div>\n'
  + '              <div style="font-size:0.9em;color:#5a6d80">Événements</div>\n'
  + '            </td>\n'
  + '            <td width="33.3%" style="background-color:#f9f9f9;padding:12px;border-radius:6px">\n'
  + '              <div style="font-size:1.5em;font-weight:bold;color:#1976d2">{{alarm.v.total_state_changes}}</div>\n'
  + '              <div style="font-size:0.9em;color:#5a6d80">Changements d\'État</div>\n'
  + '            </td>\n'
  + '          </tr>\n'
  + '        </tbody></table>\n'
  + '      </td>\n'
  + '    </tr>\n'
  + '  </tbody></table>\n'
  + '\n'
  + '  {{!-- CARD 4: SUIVI OPÉRATIONNEL --}}\n'
  + '  <table width="100%" style="background-color:#ffffff;border:1px solid #e0e0e0;border-radius:8px;margin-bottom:16px">\n'
  + '    <tbody><tr>\n'
  + '      <td>\n'
  + '        <h3 style="margin:0 0 12px 0;font-size:1.2em">Suivi Opérationnel</h3>\n'
  + '        {{#if alarm.pbehavior}}\n'
  + '          <div style="background-color:#e3f2fd;color:#1565c0;padding:12px;border-radius:6px;margin-bottom:15px;display:flex;align-items:center;gap:12px">\n'
  + '            <i class="v-icon notranslate material-icons theme--light" style="font-size:24px;color:#1565c0">pause_circle_outline</i>\n'
  + '            <div>\n'
  + '              <strong style="display:block">Comportement périodique actif</strong>\n'
  + '              {{alarm.pbehavior.name}} ({{alarm.pbehavior.type.name}})\n'
  + '            </div>\n'
  + '          </div>\n'
  + '        {{/if}}\n'
  + '\n'
  + '        {{#if alarm.v.comments}}\n'
  + '          <h4 style="margin:16px 0 8px 0">Commentaires</h4>\n'
  + '          {{#each alarm.v.comments}}\n'
  + '            <div style="border-bottom:1px solid #f0f0f0;padding:10px 0;display:flex;align-items:flex-start;gap:12px">\n'
  + '              <i class="v-icon notranslate material-icons theme--light" style="font-size:20px;color:#757575;margin-top:3px">comment</i>\n'
  + '              <div>\n'
  + '                <strong style="color:#2c3e50">{{this.a}}</strong>\n'
  + '                <span style="color:#5a6d80;font-size:0.85em">(le {{timestamp this.t}})</span>\n'
  + '                <p style="margin:4px 0 0 0;font-style:italic">"{{this.m}}"</p>\n'
  + '              </div>\n'
  + '            </div>\n'
  + '          {{/each}}\n'
  + '        {{/if}}\n'
  + '\n'
  + '        {{#if alarm.v.tickets}}\n'
  + '          <h4 style="margin:16px 0 8px 0">Historique des tickets</h4>\n'
  + '          <ul style="margin:0;padding-left:20px;list-style-type:disc">\n'
  + '            {{#each alarm.v.tickets}}\n'
  + '              <li style="padding-bottom:4px">\n'
  + '                <a target="_blank" href="{{this.ticket_url}}">{{this.ticket}}</a> - créé par {{this.a}}\n'
  + '              </li>\n'
  + '            {{/each}}\n'
  + '          </ul>\n'
  + '        {{/if}}\n'
  + '      </td>\n'
  + '    </tr>\n'
  + '  </tbody></table>\n'
  + '\n'
  + '  {{!-- CARD 5: INFORMATIONS D\'ENRICHISSEMENT --}}\n'
  + '  <table width="100%" style="background-color:#ffffff;border:1px solid #e0e0e0;border-radius:8px">\n'
  + '    <tbody><tr>\n'
  + '      <td>\n'
  + '        <h3 style="margin:0 0 12px 0;font-size:1.2em">Informations d\'Enrichissement</h3>\n'
  + '        <table width="100%">\n'
  + '          <tbody><tr style="vertical-align:top">\n'
  + '            <td width="33.3%" style="padding-right:10px">\n'
  + '              <strong style="display:block;margin-bottom:8px">Infos Entité (Ressource)</strong>\n'
  + '              <ul style="margin:0;padding:0;list-style:none;font-size:0.9em">\n'
  + '                {{#each alarm.entity.infos}}\n'
  + '                  <li style="padding-bottom:4px"><strong>{{this.name}}:</strong> {{this.value}}</li>\n'
  + '                {{/each}}\n'
  + '              </ul>\n'
  + '            </td>\n'
  + '            <td width="33.3%" style="padding-left:10px;border-left:1px solid #e0e0e0">\n'
  + '              <strong style="display:block;margin-bottom:8px">Infos Composant</strong>\n'
  + '              <ul style="margin:0;padding:0;list-style:none;font-size:0.9em">\n'
  + '                {{#each alarm.entity.component_infos}}\n'
  + '                  <li style="padding-bottom:4px"><strong>{{this.name}}:</strong> {{this.value}}</li>\n'
  + '                {{/each}}\n'
  + '              </ul>\n'
  + '            </td>\n'
  + '            <td width="33.3%" style="padding-left:10px;border-left:1px solid #e0e0e0">\n'
  + '              <strong style="display:block;margin-bottom:8px">Infos Alarme (Dynamiques)</strong>\n'
  + '              {{#if alarm.v.infos}}\n'
  + '                <ul style="margin:0;padding:0;list-style:none;font-size:0.9em">\n'
  + '                  {{#each alarm.v.infos}}\n'
  + '                    {{#each this}}\n'
  + '                      <li style="padding-bottom:4px"><strong>{{@key}}:</strong> {{this}}</li>\n'
  + '                    {{/each}}\n'
  + '                  {{/each}}\n'
  + '                </ul>\n'
  + '              {{else}}\n'
  + '                <p style="margin:0;font-size:0.9em;color:#757575;font-style:italic">Aucune info dynamique.</p>\n'
  + '              {{/if}}\n'
  + '            </td>\n'
  + '          </tr>\n'
  + '        </tbody></table>\n'
  + '      </td>\n'
  + '    </tr>\n'
  + '  </tbody></table>\n'
  + '</div>\n';

/**
 * Timeout to wait for the pbehavior to be created or removed
 */
export const ALARM_LIST_FAST_PBEHAVIOR_TIMEOUT = 1000;
